import { styled } from '@mui/styles';
import Box from '@mui/material/Box';

export const StyledFundraiserForm = styled(Box)(({ theme }) => ({
    '& .HeadingBox': {
        '& .MuiTypography-root': {
            textAlign: 'center'
        },
        padding: '40px 0',
        margin: 'auto',
        width: '50%',

        [theme.breakpoints.down('md')]: {
            width: '100%'
        },

        '& .Heading': {
            fontWeight: 'bold',
            marginBottom: '0.35em'
        }
    },

    '& .FundraiserFormBox': {
        width: '84%',
        margin: 'auto',
        border: `1px solid ${theme.palette.neutral.light}`,

        [theme.breakpoints.down('md')]: {
            width: '100%'
        },

        '& .FundraiserTabs': {
            display: 'flex',
            backgroundColor: '#F8F8F8',

            '& button.selected': {
                color: theme.palette.primary.main,
                borderBottom: `5px solid ${theme.palette.primary.main}`,
                opacity: 1
            },

            '& button': {
                textTransform: 'unset',
                maxWidth: 'unset',
                width: '50%',
                fontSize: '15px',
                fontWeight: 'bold',
                '& svg': { marginRight: '10px' }
            },

        },
        '& .TabsContent': {
            padding: '40px',

            [theme.breakpoints.down('md')]: {
                padding: '20px'
            },

            '& .MuiTabPanel-root': {
                padding: 0
            },

            '& .BasicInfoTab': {
                '& .currency-box-out': {
                    width: '100%'
                },
                '& .GoalImpactMessageBox': {
                    height: '40px',
                    padding: '3px 15px',
                    backgroundColor: theme.palette.neutral.light,
                    display: 'flex',
                    alignItems: 'center',
                    flexBasis: '70%',

                    [theme.breakpoints.down('md')]: {
                        padding: '15px'
                    },

                    '& .MuiTypography-root': {
                        lineHeight: '14px',
                        fontSize: '13px'
                    }
                },

                '& .FundraiserTypeLabel': {
                    color: 'black'
                },

                '& .FundraiserTypeStack': {
                    marginTop: '10px',

                    '& .TypeRadioLabel': {
                        '& .MuiTypography-root': {
                            fontWeight: 600
                        },
                        marginBottom: 0
                    },

                    '& .IndDesc': {
                        paddingLeft: '32px',

                        '& .FirstChild': {
                            borderBottom: '1px solid #d8d8d8',
                            width: '12rem',
                            paddingBottom: '5px',
                            fontSize: '14px'
                        },

                        '& .SecondChild': {
                            fontWeight: 600,
                            fontSize: '14px'
                        }
                    },

                    '& .TeamDesc': {
                        paddingLeft: '32px',
                        fontSize: '14px'
                    }
                },

                '& .KeepPagePrivateStack': {

                    flexDirection: 'row',
                    alignItems: 'center',

                    '& .Switch': {
                        '& .MuiFormControlLabel-root': {
                            marginBottom: 0,
                            marginRight: 0
                        },
                        '& .MuiTypography-root': {
                            fontSize: '14px'
                        }
                    },
                }
            },
        },

        '& .TellaStoryTab': {
            '& .CampaignOccasiong .MuiAutocomplete-root': {
                flexBasis: '50%'
            },

            '& .FundraiserCoverImage': {
                width: '100%',
                minHeight: '200px'
            },

            '& .FundraiserImageLoader': {
                minHeight: '200px',
                width: '100%',
                justifyContent: 'center',
                alignItems: 'center',
                '& img': {
                    width: '50px',
                }
            },

            '& .FundraiserCoverButtons': {
                '& .MuiButton-root': {
                    // display: 'flex',
                    // flexDirection: 'column',
                    flexBasis: '50%',
                    border: `1px solid ${theme.palette.neutral.light}`,
                    fontSize: '16px',

                    '& svg': {
                        marginBottom: '8px',
                        marginLeft: '5px'
                    }
                }
            },

            '& .reactEasyCrop_Container': {
                height: '450px',
                position: 'unset',

                // [theme.breakpoints.down('sm')]: {
                //     height: '180px',
                // },

                '& img': {
                    position: 'unset',
                    width: '100%',
                    height: '100%',
                    objectFit: 'cover'
                },

                '& .reactEasyCrop_CropArea': {
                    position: 'unset',
                    transform: 'unset',
                    boxShadow: 'none'
                }
            }
        }
    }
}));
